import utils from '@eitje/utils'
import {Link as RouterLink} from 'react-router'
import {Text} from '..'

// This is a rough mirror of `/web/src/components/routing/link.js`
// so the bridge consumers can use them agnostically
export const Link = ({children, disabled, style, to, state, className, tabIndex, t, onClick, onNewTabIntent}) => {
	const classNameOverride = utils.makeCns(className, 'link', 'eitje-link', disabled && 'disabled')
	const handleClick = e => {
		onClick?.(e)

		const hasNewTabIntent = e.metaKey || e.ctrlKey || e.shiftKey

		// We are ignoring new tab intent via context
		if (!e.defaultPrevented && hasNewTabIntent) {
			onNewTabIntent?.(e)
		}
	}

	// `onClick` does not catch `middle-click` so we need an extra handler for that
	const handlePointerDown = e => {
		if (e.button === 1) {
			onNewTabIntent?.(e)
		}
	}

	const isRawText = typeof children === 'string' || typeof children === 'number' || Boolean(t)
	let content = children
	if (isRawText) {
		content = (
			<Text t={t} hyperlink={!disabled}>
				{children}
			</Text>
		)
	}

	if (disabled)
		return (
			<span className={classNameOverride} style={{display: 'inline-block', ...style}}>
				{content}
			</span>
		)

	return (
		<RouterLink
			onClick={handleClick}
			onPointerDown={handlePointerDown}
			to={to}
			state={state}
			className={classNameOverride}
			style={style}
			tabIndex={tabIndex}
		>
			{content}
		</RouterLink>
	)
}
